//
//
//

import Service from '@/service/building'
import PService from '@/service/public'
import WX_API from '@/utils/wx_api'
import canvas_save from '@/common/mixins/canvas_save'
import { LEVEL_MAP } from '@/constant'
import { handleImgSize } from '@/common/utils/map_view_data'
import { strokeRectWidthRadius, drawCircleImg } from '@/common/utils/canvas'
export default {
    mixins: [
        canvas_save
    ],
    props: {
        consultant: Object,
        show: Boolean,
        house: Object,
        currrent_house: Object,
        show_720: Boolean,
        show_vr: Boolean,
        is_building_consultant: Boolean
    },
    data () {
        return {
            qr_code: ''
        }
    },
    watch: {
        show (latest) {
            if (latest) {
                const { building_id, category_id } = this.$route.query
                const PREFIX_MAP = {
                    'pages/building/main': {
                        prefix: 'bb',
                        jump_page: 'pages/index/main'
                    },
                    'building/business': {
                        prefix: 'bb',
                        jump_page: 'pages/index/main'
                    },
                    'pages/building/web_720/main': {
                        prefix: 'cdpanoramab',
                        jump_page: 'pages/building/main'
                    },
                    'building/web_vr': {
                        prefix: `cdvrb`,
                        suffix: `-${category_id}`,
                        jump_page: 'pages/building/main'
                    }
                }
                let prefix = 'bb'
                let suffix = ''
                let jump_page = 'pages/index/main'
                if (this.$root.__route__) {
                    const res = PREFIX_MAP[this.$root.__route__]
                    prefix = res.prefix
                    suffix = res.suffix || ''
                    jump_page = res.jump_page
                }
                PService.getSceneQr({
                    scene: `${prefix}_${building_id}${suffix}`,
                    jump_page
                }).then(({ qrcode }) => {
                    this.qr_code = `${qrcode}?x-oss-process=image/resize,w_120,h_120`
                    this.generateImg()
                    this.save()
                })
            }
        },
        tmp_img_path (latest) {
            if (latest) {
                this.$emit('drawComplete', latest)
            }
        }
    },
    methods: {
        saveImgSuccess () {
            this.$emit('success')
        },
        async generateImg () {
            const [photoTemp, qrTemp, consultantHeadimg, logoImg] = await Promise.all([this.getHouseImg(), this.getHouseQr(), this.getConsultantHeadimg(), this.getLogoImg()])
            this.drawImg(photoTemp, qrTemp, consultantHeadimg, logoImg)
        },
        async getHouseImg () {
            const { photos_urls = [], vr_panorama_resource, vr_resource }  = this.house
            let houseImg = photos_urls && photos_urls.length ? handleImgSize(photos_urls[0], 560, 373) : 'https://cdn.vip-wifi.com/fangchan/img/house-detail/billboard-default-img.png?x-oss-process=image/resize,w_460,h_306'
            const cover_720 = vr_panorama_resource && vr_panorama_resource.cover_image_url ? vr_panorama_resource.cover_image_url : ''
            const cover_vr = vr_resource && vr_resource.vr_photo_url ? vr_resource.vr_photo_url : ''
            if (cover_720 && this.show_720) {
                houseImg = handleImgSize(cover_720, 560, 373)
            } else if (cover_vr && this.show_vr) {
                houseImg = handleImgSize(cover_vr, 560, 373)
            }
            const { path }= await WX_API.getImgInfo(houseImg)
            return path
        },
        async getHouseQr () {
            const { path } = await WX_API.getImgInfo(this.qr_code)
            return path
        },
        async getConsultantHeadimg () {
            const { path } = await WX_API.getImgInfo(this.consultant.weixin_headimgurl)
            return path
        },
        async getLogoImg () {
            let logo_img = ''
            if (this.show_720) {
                logo_img = 'https://cdn.vip-wifi.com/fangchan/img/building/helicopter.png'
            } else if (this.show_vr) {
                logo_img = 'https://cdn.vip-wifi.com/fangchan/img/building/vr.png'
            }
            if (!logo_img) {
                return ''
            }
            const { path } = await WX_API.getImgInfo(logo_img)
            return path
        },
        drawImg (photoTemp, qrTemp, consultantHeadimg, logoImg) {
            console.error('draw start')
            const canvasId = 'house-canvas'
            const { name,  zone, status, address, price_desc_arr } = this.house
            const { area_range } = this.current_house || {}
            const building_area = this.house.details ? this.house.details['占地面积'] : ''
            const status_text = status
            const ctx = wx.createCanvasContext(canvasId, this.$mp.component)
            const CANVAS_WIDTH = 560
            const CANVAS_HEIGHT = 963
            const PHOTO_HEIGHT = 373
            ctx.textBaseline = 'top'

            // draw background
            ctx.setFillStyle('#FFFFFF')
            ctx.fillRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT)

            // draw photo
            ctx.drawImage(photoTemp, 0, 0, CANVAS_WIDTH, PHOTO_HEIGHT)
            console.error('logoImg', logoImg)
            if (logoImg) {
                ctx.drawImage(logoImg, 231, 138, 98, 98)
            }

            // draw buidling name
            const BUILDING_INFO_LEFT = 24
            ctx.setFillStyle('#333333');
            ctx.setTextAlign('left')
            ctx.font = 'normal bold 36px PingFang SC'
            ctx.fillText(name, BUILDING_INFO_LEFT, PHOTO_HEIGHT + 16)

            // draw zone tag
            if (zone && status) {
                ctx.font = 'normal 20px PingFang SC'
                const zone_tag_text = `${zone} | ${status_text}`
                const ZONE_TAG_PADDING = 10
                const zone_tag_width = ctx.measureText(zone_tag_text).width + ZONE_TAG_PADDING * 2
                const zone_tag_height = 32
                const ZONE_TAG_TOP = PHOTO_HEIGHT + 76
                strokeRectWidthRadius(ctx, {
                    left: BUILDING_INFO_LEFT,
                    top: ZONE_TAG_TOP,
                    width: zone_tag_width,
                    height: zone_tag_height,
                    radius: 2,
                    fill_style: '#E9F3F8'
                })
                ctx.setFillStyle('#737C92');
                ctx.setTextAlign('left')
                ctx.fillText(zone_tag_text, BUILDING_INFO_LEFT + ZONE_TAG_PADDING, PHOTO_HEIGHT + 78)
            }

            let BUILDING_INFO_TOP = 132 + PHOTO_HEIGHT
            const TEXT_LINE_HEIGHT = 37
            const LABEL_FONT = 'normal 24px PingFang SC'
            const LABEL_STYLE = '#999999'
            const LABEL_WIDTH = 120
            const LABEL_CONTENT_LEFT = LABEL_WIDTH + BUILDING_INFO_LEFT
            ctx.setTextAlign('left')
            if (price_desc_arr && price_desc_arr.length) {
                ctx.font = LABEL_FONT
                ctx.setFillStyle(LABEL_STYLE)
                ctx.fillText('参考价格：', BUILDING_INFO_LEFT, BUILDING_INFO_TOP, LABEL_WIDTH)
                ctx.font = 'normal bold 24px PingFang SC'
                ctx.setFillStyle('#FA4B00')
                price_desc_arr.forEach((price) => {
                    ctx.fillText(price, LABEL_CONTENT_LEFT, BUILDING_INFO_TOP)
                    BUILDING_INFO_TOP += TEXT_LINE_HEIGHT
                })
            }

            if (area_range) {
                ctx.font = LABEL_FONT
                ctx.setFillStyle(LABEL_STYLE)
                ctx.fillText('户型建面：', BUILDING_INFO_LEFT, BUILDING_INFO_TOP, LABEL_WIDTH)
                ctx.font = 'normal 24px PingFang SC'
                ctx.setFillStyle('#333333')
                ctx.fillText(area_range, LABEL_CONTENT_LEFT, BUILDING_INFO_TOP)
                BUILDING_INFO_TOP += TEXT_LINE_HEIGHT
            }
            if (building_area) {
                ctx.font = LABEL_FONT
                ctx.setFillStyle(LABEL_STYLE)
                ctx.fillText('占地面积：', BUILDING_INFO_LEFT, BUILDING_INFO_TOP, LABEL_WIDTH)
                ctx.font = 'normal 24px PingFang SC'
                ctx.setFillStyle('#333333')
                ctx.fillText(building_area, LABEL_CONTENT_LEFT, BUILDING_INFO_TOP)
                BUILDING_INFO_TOP += TEXT_LINE_HEIGHT
            }

            if (address) {
                console.error('before draw address', BUILDING_INFO_TOP)
                // draw address
                const ADDRESS_MAX_WIDTH = 386
                const ADDRESS_TOP = BUILDING_INFO_TOP
                ctx.font = LABEL_FONT
                ctx.setFillStyle(LABEL_STYLE)
                ctx.fillText('楼盘地址：', BUILDING_INFO_LEFT, ADDRESS_TOP, LABEL_WIDTH)
                ctx.setFillStyle('#333333')
                const address_width = ctx.measureText(address).width
                console.error('address_width', address_width)
                if (address_width <= ADDRESS_MAX_WIDTH) {
                    ctx.fillText(address, BUILDING_INFO_LEFT + LABEL_WIDTH, ADDRESS_TOP, ADDRESS_MAX_WIDTH)
                    BUILDING_INFO_TOP += TEXT_LINE_HEIGHT
                } else {
                    let tmp_address = ''
                    let line = 0
                    for (let i = 0; i < address.length; i++) {
                        tmp_address += address[i]
                        const temp_address_width = ctx.measureText(tmp_address).width
                        if (i === address.length - 1 || (ADDRESS_MAX_WIDTH - temp_address_width <= 24)) {
                            if (line === 1 && i < address.length - 1) {
                                tmp_address += '...'
                            }
                            ctx.fillText(tmp_address, BUILDING_INFO_LEFT + LABEL_WIDTH, BUILDING_INFO_TOP, ADDRESS_MAX_WIDTH)
                            tmp_address = ''
                            line++
                            BUILDING_INFO_TOP += TEXT_LINE_HEIGHT
                        }
                        if (line === 2) {
                            break
                        }
                    }
                }
            }
            console.error('after draw address', BUILDING_INFO_TOP)
            // BOTTOM SECTION
            const BOTTOM_SECTION_WIDTH = 512
            const BOTTOM_SECTION_HEIGHT = 170
            const BOTTOM_SECTION_TOP = BUILDING_INFO_TOP + 38
            ctx.setFillStyle('#F7F7F7')
            ctx.fillRect(BUILDING_INFO_LEFT, BOTTOM_SECTION_TOP, BOTTOM_SECTION_WIDTH, BOTTOM_SECTION_HEIGHT)

            // consultant
            if (this.is_building_consultant) {
                drawCircleImg(ctx, {
                    img: consultantHeadimg,
                    left: BUILDING_INFO_LEFT + 16,
                    top: BOTTOM_SECTION_TOP + 41,
                    size: 88
                })

                const CONSULANT_INFO_LEFT = 140
                const CONSULANT_INFO_TOP = BOTTOM_SECTION_TOP + 30
                ctx.setFillStyle('#333333')
                ctx.setTextAlign('left')
                ctx.font = 'normal bold 32px PingFang SC'
                ctx.fillText(this.consultant.name, CONSULANT_INFO_LEFT, CONSULANT_INFO_TOP)
                const consultant_name_width = ctx.measureText(this.consultant.name).width

                const CONSULTANT_LEVEL_BG_LEFT = CONSULANT_INFO_LEFT + consultant_name_width + 8
                ctx.setFillStyle('#DAF7F3')
                ctx.fillRect(CONSULTANT_LEVEL_BG_LEFT, CONSULANT_INFO_TOP + 4, 86, 32)

                ctx.setFillStyle('#00C2A7')
                ctx.font = 'normal 18px PingFang SC'
                const level = this.consultant.level === 'copper' ? '置业顾问' : `${LEVEL_MAP[this.consultant.level]}顾问`
                ctx.fillText(level, CONSULTANT_LEVEL_BG_LEFT + 6, CONSULANT_INFO_TOP + 8)

                ctx.setFillStyle('#666666')
                ctx.font = 'normal 22px PingFang SC'
                ctx.fillText(`微信：${this.consultant.weixin_name || ''}`, CONSULANT_INFO_LEFT + 4, CONSULANT_INFO_TOP + 50)
                ctx.fillText(`手机：${this.consultant.mobile}`, CONSULANT_INFO_LEFT + 4, CONSULANT_INFO_TOP + 50 + 30)
            }

            // // draw qr
            const QR_LEFT = this.is_building_consultant ? 395 : 228
            const QR_TOP = BOTTOM_SECTION_TOP + 20
            const QR_SIZE = 104
            strokeRectWidthRadius(ctx, {
                left: QR_LEFT,
                top: QR_TOP,
                width: QR_SIZE,
                height: QR_SIZE,
                radius: 4,
                stroke_style: '#EDEDED',
                line_width: 2,
                clip: true
            })
            ctx.drawImage(qrTemp, QR_LEFT, QR_TOP, QR_SIZE, QR_SIZE)
            // draw qr tx
            ctx.setFillStyle('#B2B2B2');
            ctx.setFontSize(20)
            let qr_tip = '长按查看楼盘详情'
            if (this.show_720) {
                qr_tip = '长按体验航拍看房'
            } else if (this.show_vr) {
                qr_tip = '长按体验VR看房'
            }
            const QR_TX_LEFT = QR_LEFT + QR_SIZE / 2
            ctx.setTextAlign('center')
            ctx.fillText(qr_tip, QR_TX_LEFT, BOTTOM_SECTION_TOP + 136)

            const img_height = BOTTOM_SECTION_TOP + BOTTOM_SECTION_HEIGHT + 23

            this.$emit('changeHeight', img_height)

            console.error('draw end')
            ctx.draw(true, () => {
                this.finishDraw({
                    canvasId,
                    width: CANVAS_WIDTH,
                    height: img_height
                })
            })
        }
    }
}
